/* eslint eqeqeq: "off" */
import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import Itineries from "../../assets/images/benefits/customized-itineries.png";
import Wallet from "../../assets/images/benefits/wallets.png";
import Deals from "../../assets/images/benefits/deals.png";
import Support from "../../assets/images/benefits/24-hours-support.png";

import { Col, Image, Row } from "antd";
import useMedia from "use-media-antd-query";

const Benefits = [
  {
    imageUrl: Itineries,
    name: "Cutomized Itineries",
    message:
      "Enjoy our bespoke tour packages that can be tailored according to your preferences for a personalised experience.",
  },
  {
    imageUrl: Wallet,
    name: "Wallet-Friendly Prices",
    message:
      "Every traveller from worldwide can embark on unforgettable journeys with our unbeatable holiday package prices.",
  },
  {
    imageUrl: Deals,
    name: "Exciting Deals",
    message:
      "Our platform comprises perfect deals and discounts on all exclusive holiday packages to ensure value-for-money.",
  },
  {
    imageUrl: Support,
    name: "24/7 Support",
    message:
      "Our customer support team is always available to assist you and resolve travel-related queries instantly.",
  },
];

const Benifits = () => {
  const media = useMedia();
  return (
    <React.Fragment>
      <Col
        md={24}
        lg={24}
        xl={24}
        xxl={24}
        className={
          media == "sm" || media == "xs"
            ? "mt-[50px] pl-[40px] pr-[40px]"
            : "mt-[70px] pl-[80px] pr-[80px]"
        }
      >
        <Row>
          <Col
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className="pl-5 pr-5 pt-3 pb-3 bg-[#f9f9f9]"
          >
            <div
              style={{
                fontFamily: "Poppins",
                marginBottom: "1.5rem",
                //   boxShadow: "1px 1px 1px 2px lightgray",
              }}
            >
              <div className="flex text-[24px] font-extrabold text-start ">
                <h2 className="text-[#eb3a3e]">Benefits</h2>
                <span className="ml-1">of Booking With Us</span>
              </div>
              <p className="text-[14px] mt-2 font-medium text-start">
                Discover the unrivalled benefits that promises memorable
                journeys all along.
              </p>
            </div>
            <Row className="flex flex-row">
              {Benefits.map((data, index) => {
                return (
                  <Col
                    md={6}
                    lg={6}
                    xl={6}
                    xxl={6}
                    key={index}
                    className={
                      (index === 3 && media == "sm") || media == "xs"
                        ? "pr-5"
                        : (index === 3 && media !== "sm") || media !== "xs"
                        ? "pr-2"
                        : "pr-5"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        //   boxShadow: "1px 1px 1px 2px lightgray",
                        border: "1px solid #eb3a3e",
                        height:
                          media === "sm" ||
                          media === "xs" ||
                          media === "md" ||
                          media == "lg"
                            ? ""
                            : "225px",
                      }}
                      key={index}
                      className={
                        data.name == "Exciting Deals"
                          ? "cursor-pointer pt-4 pb-5 pl-3 pr-3 mb-3 bg-white shadow-lg rounded-xl"
                          : data.name == "24/7 Support"
                          ? "cursor-pointer pt-4 pb-5 pl-3 pr-3 mb-3 bg-white shadow-lg rounded-xl"
                          : "cursor-pointer p-4 mb-3 bg-white shadow-lg rounded-xl"
                      }
                    >
                      <div className="text-center">
                        <Image
                          src={data.imageUrl}
                          preview={false}
                          height={40}
                          width={40}
                          className="text-center"
                        />
                        <h1 className="mt-2 text-[15px] mb-3 text-sm font-bold">
                          {data.name}
                        </h1>
                        <p className="text-[15px]">{data.message}</p>
                      </div>
                    </div>
                  </Col>
                );
              })}
              {/* <Row>
                  <Col md={24} lg={24} xl={24} xxl={24}>
                  </Col>
                </Row> */}
            </Row>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default Benifits;
